module.exports = __webpack_public_path__ + "img/188.2372198f.jpg";